module.exports = __webpack_public_path__ + "img/Modernisme_Episke_forfattere5.22053ca5.jpg";